import React from 'react';
import PropTypes from 'prop-types';
// import { applicationHistory } from '../../common/application-history';
import { connect } from 'react-redux';
import {setAlbumViewMode, setUploadViewMode} from '../actions/snapfish-actions';

import '../../navigation/style/navigation.scss';

const SnapfishNavigation = props => {

	return (
		<div className="left-nav" role="navigation">
			<div className="navigation-container snapfish-navigation-container">
				<div className={`navigation-selection-container hidden`} aria-labelledby="timeline">
					<div className={`navigation-selection-item ${getSelectedClass(props,'timeline')}`} />
					<div className="navigation-button-container" onClick={()=>{}}>
						<div className="navigation-button timeline" />
						<span>Timeline</span>
					</div>
				</div>
				<div className={`navigation-selection-container`} aria-labelledby="albums">
					<div className={`navigation-selection-item ${getSelectedClass(props, 'album')}`} />
					<div className="navigation-button-container" onClick={() => props.showAlbums()}>
						<div className="navigation-button album" />
						<span>Albums</span>
					</div>
				</div>
				<div className={`navigation-selection-container`} aria-labelledby="upload">
					<div className={`navigation-selection-item ${getSelectedClass(props, 'upload')}`} />
					<div className="navigation-button-container" onClick={() => props.showUpload()}>
						<div className="navigation-button upload" />
						<span>Upload</span>
					</div>
				</div>
			</div>
		</div>
	);
};


const getSelectedClass = (props, pageName) => {

	if (props.featureImOn === pageName) return 'selected';
	return '';
};



SnapfishNavigation.propTypes = {
    featureImOn: PropTypes.string,


};

const mapStateToProps = state => {
	return {
		featureImOn: state.snapfish.viewMode,

	};
};


const mapDispatchToProps = (dispatch) => {
    return {
        showUpload: () => {
            dispatch(setUploadViewMode());
        },
        showAlbums: ()=> {
            dispatch(setAlbumViewMode());
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(SnapfishNavigation);


// WEBPACK FOOTER //
// ./src/snapfish/components/snapfish-navigation.jsx